var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHideText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "show_password",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87817 4.46623L10.1686 6.75662L10.1795 6.63665C10.1795 5.43327 9.20152 4.45532 7.99815 4.45532L7.87817 4.46623Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99855 3.00111C10.0054 3.00111 11.6341 4.62984 11.6341 6.63666C11.6341 7.10564 11.5396 7.55281 11.376 7.96361L13.5028 10.0904C14.6007 9.17425 15.466 7.98908 16.0004 6.63666C14.7389 3.44467 11.6377 1.18335 7.99859 1.18335C6.98062 1.18335 6.00632 1.36512 5.10107 1.69231L6.67163 3.25922C7.0824 3.09927 7.52957 3.00111 7.99855 3.00111Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.727096 1.01971L2.3849 2.67752L2.71575 3.00836C1.51602 3.94633 0.567144 5.19333 0 6.63662C1.25791 9.82861 4.36265 12.0899 7.99819 12.0899C9.12522 12.0899 10.2013 11.8718 11.1866 11.4755L11.4956 11.7845L13.6151 13.9077L14.5422 12.9843L1.65416 0.0926514L0.727096 1.01971ZM4.74802 5.03699L5.8714 6.16038C5.83868 6.31671 5.81687 6.47302 5.81687 6.63662C5.81687 7.83999 6.79482 8.81794 7.99819 8.81794C8.16179 8.81794 8.31813 8.79613 8.47083 8.76341L9.59421 9.88679C9.11067 10.1267 8.57263 10.2722 7.99819 10.2722C5.99138 10.2722 4.36265 8.64344 4.36265 6.63662C4.36265 6.06222 4.50808 5.52414 4.74802 5.03699Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideText);
export default __webpack_public_path__ + "static/media/hide_text.62a4051440a4e6e2290b89d0c0337d16.svg";
export { ForwardRef as ReactComponent };